import { ModelCollection } from '/@/modules/core/app/models/ModelCollection';
import { EmbedUrl } from '@/modules/embedurl/models/EmbedUrl';
import { EmbedUrlIndentifier } from '@/modules/embedurl/constants/EmbedUrlIndentifier';

export class EmbedUrlCollection extends ModelCollection<EmbedUrl> {
  constructor(items: EmbedUrl[] | null = null) {
    super(items, EmbedUrl);
  }

  static mapModel(items: EmbedUrl[] | null = null): EmbedUrlCollection {
    return new this(items);
  }

  get executorWelcomeVideo(): EmbedUrl | undefined {
    return this.getEmbedUrlByType(EmbedUrlIndentifier.EXECUTOR_WELCOME_VIDEO);
  }

  get dutiesOfExecutorVideo(): EmbedUrl | undefined {
    return this.getEmbedUrlByType(EmbedUrlIndentifier.DUTIES_OF_EXECUTOR_VIDEO);
  }

  get dutiesOfExecutorGoogleSlide(): EmbedUrl | undefined {
    return this.getEmbedUrlByType(EmbedUrlIndentifier.DUTIES_OF_EXECUTOR_GOOGLE_SLIDE);
  }

  get clearEstateComesInVideo(): EmbedUrl | undefined {
    return this.getEmbedUrlByType(EmbedUrlIndentifier.CLEARESTATE_COMES_IN_VIDEO);
  }

  get clearEstateComesInGoogleSlide(): EmbedUrl | undefined {
    return this.getEmbedUrlByType(EmbedUrlIndentifier.CLEARESTATE_COMES_IN_GOOGLE_SLIDE);
  }

  get assessVideo(): EmbedUrl | undefined {
    return this.getEmbedUrlByType(EmbedUrlIndentifier.ASSESS_VIDEO);
  }

  get assessGoogleSlide(): EmbedUrl | undefined {
    return this.getEmbedUrlByType(EmbedUrlIndentifier.ASSESS_GOOGLE_SLIDE);
  }

  private getEmbedUrlByType(identifier: EmbedUrlIndentifier): EmbedUrl | undefined {
    return this.items?.find((item: EmbedUrl) => item.identifier === identifier);
  }
}
